import { withInstall } from '@ll-plus/utils'

import Pagination from './src/components/pagination.vue'
import Table from './src/table.vue'

export const LlTable = withInstall(Table)
export const LlPagination = withInstall(Pagination)
export default LlTable
export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlTable: typeof Table
    LlPagination: typeof Pagination
  }
}
